import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeAnalyzeRecommendations from './CadeAnalyzeRecommendations';
import CadeAnalyzeRadar from './CadeAnalyzeRadar';
import { getCadeModeForName } from '../../helpers/CadeComponentHelpers';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';

import './CadeAnalyze.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';


class CadeAnalyzeAssessmentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            cadeModeFor: props.cadeModeFor,
            personAge: props.personAge,
            numUnansweredItems: 0,
            asdScore: 0,
            asdConcern: "No Concern",
            domainConcerns: [],
            asdLevels: [],
            concerns: [], 
            asdProbability: null,
            noProbability: null,
            mildProbability: null,
            moderateProbability: null,
            significantProbability: null,
            clinicianAsdDiagnosis: null,
            nonClinicianAsdDiagnosis: null,
            numConcerns: 0,
            numFlags: 0,
            cgName: null,
            r1Name: null,
            r2Name: null
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get an AsdAssessmentModel
         */

        let url = "assessment/" + this.state.assessmentId +  "/caiu/" + authService.authenticatedUserId + "/asdanalyze/" + this.state.cadeModeFor;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    this.setState({
                        numUnansweredItems: response.data.numUnansweredItems,
                        asdScore: response.data.asdScore,
                        asdConcern: response.data.asdConcern,
                        domainConcerns: response.data.domainConcerns,
                        asdLevels: response.data.asdLevels,
                        concerns: response.data.concerns,
                        asdConfidence: response.data.asdConfidence,
                        noProbability: response.data.noRangeProbability,
                        mildProbability: response.data.mildRangeProbability,
                        moderateProbability: response.data.moderateRangeProbability,
                        significantProbability: response.data.significantRangeProbability,
                        clinicianAsdDiagnosis: response.data.clinicianAsdDiagnosis,
                        nonClinicianAsdDiagnosis: response.data.nonClinicianAsdDiagnosis,
                        numConcerns: response.data.numConcerns,
                        numFlags: response.data.numFlags,
                        cgName: response.data.raters[2].raterName,
                        r1Name: response.data.raters[0].raterName,
                        r2Name: response.data.raters[1].raterName
                    });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    handleClinicianInput = (e) => {
        let asdDiag = null;
        let which = null;
        switch (e.currentTarget.id) {
            case "asdYes":
                asdDiag = true;
                which = "cl";
                break;
            case "asdNo":
                asdDiag = false;
                which = "cl";
                break;
            case "asdNa":
                asdDiag = null;
                which = "cl";
                break;
            case "nclAsdYes":
                asdDiag = true;
                which = "ncl";
                break;
            case "nclAsdNo":
                asdDiag = false;
                which = "ncl";
                break;
            case "nclAsdNa":
                asdDiag = null;
                which = "ncl";
                break;
        }
        if (which == "cl") {
            this.setState({ clinicianAsdDiagnosis: asdDiag });
        }
        if (which == "ncl") {
            this.setState({ nonClinicianAsdDiagnosis: asdDiag });
        }

        let url = "/assessment/" + this.state.assessmentId + "/asddiag";
        api.post(url, { assessmentId: this.state.assessmentId, asdDiagnosis: asdDiag, who: which },
            {
                headers: {
                    Authorization: 'Bearer ' + authService.token
                }
            })
            .then((response) => {
                if (response.status != 200) {
                    apiErrorPopup(apiResponseHandler(response));
                };
            })
            .catch((error) => {
                // Major problem!
                apiErrorPopup(apiErrorHandler(error));
                return;
            });

    }

    render() {
        let who = getCadeModeForName(authService.userType, this.state.cadeModeFor, this.state.r1Name, this.state.r2Name, this.state.cgName);
        let domainTitle = "Clear Child Assessment Summary";
        let domainDesc = "Assessment Analysis";

        let concernTitle = (this.state.asdConcern == "No Concern") ? this.state.asdConcern : this.state.asdConcern + " Concern";
        let headerTitle = null;
        if (this.state.personAge >= 3) {
            headerTitle = (this.state.numUnansweredItems == 0) ? "Clear Child ASD Assessment: " + concernTitle : "Unable to Complete Clear Child Assessment: " + this.state.numUnansweredItems + " Unanswered Items";
        }
        else {
            headerTitle = (this.state.numUnansweredItems == 0) ? "Clear Child Assessment Summary" : "Unable to Complete Clear Child Assessment: " + this.state.numUnansweredItems + " Unanswered Items";
        }

        const score = this.state.asdScore;
        const asdLevels = this.state.asdLevels;
        const asdData = [{ name: 'ASD Score: ' + score, None: asdLevels[0], Mild: asdLevels[1], Moderate: asdLevels[2], Significant: asdLevels[3], Score: score }];

        const pieData = [{ name: 'Concerns', value: this.state.numConcerns }, { name: "Flagged Concerns", value: this.state.numFlags }];
        const COLORS = ['#1D64AE', '#F9922C'];

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain={domainTitle}
                                subTitle={domainDesc}
                            />
                        </Col>
                        <Col sm={8}>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage="CadeAssessmentLG.png"
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />

                            <Fragment>
                                <p></p>
                                    
                                <div className="cadeAnalyze_asdScoreCircle">
                                    <p className="cadeAnalyze_asdScore">{this.state.asdScore}</p>
                                </div>
                                <p className='cadeAnalyze_asdScoreLabel'>ASD Score</p>
                                <p className='cadeAnalyze_asdScoreLabel'>Score Confidence: {this.state.asdConfidence}%</p>
                                <p className='cadeAnalyze_rangeProbabilityLabel'>Probability in Range</p>
                                <p className='cadeAnalyze_rangeProbability'>None: {this.state.noProbability}%</p>
                                <p className='cadeAnalyze_rangeProbability'>Mild: {this.state.mildProbability}%</p>
                                <p className='cadeAnalyze_rangeProbability'>Moderate: {this.state.moderateProbability}%</p>
                                <p className='cadeAnalyze_rangeProbability'>Significant: {this.state.significantProbability}%</p>
                            </Fragment>

                            <p></p>
                            <p class='cadeAnalyze_asdScoreLabel'>Your Analysis</p>
                            <p class="cadeAnalyze_clinicianDiagLabel">Did you clinically diagnose ASD?</p>
                            <Form.Check onClick={this.handleClinicianInput} inline label="Yes" type="radio" id="asdYes" checked={this.state.clinicianAsdDiagnosis == true} />
                            <Form.Check onClick={this.handleClinicianInput} inline label="No" type="radio" id="asdNo" checked={this.state.clinicianAsdDiagnosis == false} />
                            <Form.Check onClick={this.handleClinicianInput} inline label="Not Applicable" type="radio" id="asdNa" checked={this.state.clinicianAsdDiagnosis == null} />
                            <p class="cadeAnalyze_nonClinicianDiagLabel">Did you educationally identify ASD?</p>
                            <Form.Check onClick={this.handleClinicianInput} inline label="Yes" type="radio" id="nclAsdYes" checked={this.state.nonClinicianAsdDiagnosis == true} />
                            <Form.Check onClick={this.handleClinicianInput} inline label="No" type="radio" id="nclAsdNo" checked={this.state.nonClinicianAsdDiagnosis == false} />
                            <Form.Check onClick={this.handleClinicianInput} inline label="Not Applicable" type="radio" id="nclAsdNa" checked={this.state.nonClinicianAsdDiagnosis == null} />
                            
                        </Col>
                        <Col sm={8}>
                            <Row>
                                <Col sm={12}>
                                    <h3>{headerTitle}</h3>
                                    <h4>{who} Responses</h4>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12}>
                                    <ResponsiveContainer height={550}>
                                        <ComposedChart height={550} data={asdData}
                                            margin={{ top: 100, right: 20, bottom: 0, left: 0 }}>
                                            <CartesianGrid stroke='#f5f5f5' />
                                            <XAxis dataKey="name" />
                                            <YAxis domain={[0, 100]} ticks={[0, 20, 40, 60, 80, 100]} />
                                                
                                            <Legend />
                                            <Bar dataKey='None' stackId='a' barSize={100} fill='#00FF00' />
                                            <Bar dataKey='Mild' stackId='a' barSize={100} fill='yellow' />
                                            <Bar dataKey='Moderate' stackId='a' barSize={100} fill='#F9922C' />
                                            <Bar dataKey='Significant' stackId='a' barSize={100} fill='#FF0000' />
                                            <Line type='monotone' dataKey='Score' dot={{ stroke: 'black', strokeWidth: 8 }} />
                                        </ComposedChart>
                                    </ResponsiveContainer>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {this.state.numUnansweredItems == 0 &&
                        <Row>
                            <Col sm={12}>
                                <CadeAnalyzeRadar
                                    cadeModeFor={this.props.cadeModeFor}
                                    radarName="Concern Level"
                                    concernLevel={this.state.asdConcern}
                                    domainConcerns={this.state.domainConcerns}
                                    outerRadius={150}
                                />
                            </Col>
                        </Row>
                    }

                    {this.state.numUnansweredItems == 0 &&
                        <Row>
                            <Col sm={12}>
                            <CadeAnalyzeRecommendations
                                heading="Summary of Clear Child Recommendations"
                                concerns={this.state.concerns}
                                displayFlags={true}
                            />
                            </Col>
                        </Row>
                    }
                </Container>

            </Fragment>
        );
    }
}

export default CadeAnalyzeAssessmentComponent;



// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeAnalyzeAssessmentComponent.js